import styled from "styled-components";
import React from "react";
import { UIList } from "../../UI/List";
import { NumberText } from "../group/Introduce";
import { GradientText } from "./RightSection";
import { priceList } from "../Contestant/modal/PriceTable";

const process = [
  {
    label: "TRUY CẬP WEBSITE",
    content:
      "Truy cập website <strong>https://giaithuongconghien.bvote.vn</strong> để bình chọn cho Đề cử yêu thích trong từng Hạng mục Cống hiến 2023.",
  },
  {
    label: "TRUY CẬP VÍ ĐIỆN TỬ VÀ THANH TOÁN",
    content: "Tiến hành thanh toán theo đường link hệ thống trả về.",
  },
  {
    label: "THANH TOÁN THÀNH CÔNG",
    content:
      "Sau khi thanh toán thành công, hệ thống BVote sẽ tiến hành lưu trữ kết quả bình chọn. Phí bình chọn: 10.000 VNĐ/20⭐",
  },
];

export const RuleSection = () => {
  return (
    <Styles>
      <h2 id="rule-title-4">THỂ LỆ BÌNH CHỌN</h2>
      <p>
        Người tham gia có thể bình chọn không giới gian, bao gồm số lượt bình
        chọn và số đề cử bình chọn trong Giải thưởng Cống hiến 2023.
      </p>
      <div className="card">
        <h3>Vòng Đề cử</h3>
        <p style={{ marginBlock: "20px" }}>
          Mỗi hạng mục giải thưởng trong lĩnh vực Âm nhạc sẽ gồm từ 5-15 ứng
          viên đã được tuyển chọn từ Hội đồng bình chọn. Kết quả Vòng đề cử sẽ
          chọn ra top 5 đề cử vào Vòng bình chọn chung cuộc.
        </p>
        <p>
          Ứng viên có kết quả bình chọn cao nhất từ khán giả trong mỗi hạng mục
          sẽ vào thẳng Vòng bình chọn chung cuộc.
        </p>
        <p>Trong đó: </p>
        <ul>
          <li>
            Ứng viên có kết quả bình chọn cao nhất từ khán giả trong mỗi hạng
            mục sẽ vào thẳng Vòng bình chọn chung cuộc.
          </li>
          <li>
            Kết quả 4 vị trí còn lại vào vòng sau dựa trên tổng điểm bình chọn
            gồm:
            <ul>
              <li>50% số điểm từ Hội đồng bình chọn</li>
              <li>
                50% số điểm từ khán giả bình chọn = điểm đã quy đổi từ điểm sao
                ⭐ Cống hiến
              </li>
            </ul>
          </li>
        </ul>
        <h3 className="title-2">Vòng bình chọn chung cuộc</h3>
        <p>
          Mỗi hạng mục giải thưởng sẽ gồm 5 đề cử (kết quả từ vòng bình chọn top
          5 trước đó), Kết quả vòng chung cuộc sẽ chọn ra 01 đề cử xuất sắc có
          điểm số cao nhất là đề cử chiến thắng giải thưởng Cống hiến 2023 hạng
          mục đó dựa trên điểm số từ Hội đồng bình chọn & khán giả bình chọn.
        </p>
        {/* <ul>
          <li>
            50% số điểm từ phóng viên báo chí với lĩnh vực âm nhạc và hội đồng
            bình chọn với lĩnh vực thể thao
          </li>
          <li>
            50% số điểm từ khán giả bình chọn = điểm đã quy đổi từ điểm sao ⭐️
            Cống hiến, bao gồm ⭐BVote + ⭐NFT
          </li>
        </ul> */}
      </div>
      <h2 id="rule-title-5">BẢNG QUY ĐỔI</h2>
      <p>
        Số lượt bình chọn của khán giả sẽ được tính bằng Sao Cống hiến theo quy
        đổi như sau:
      </p>
      <table>
        <thead>
          <tr>
            <th>Số lượng sao</th>
            <th>Số điểm tương ứng</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>2.000 ⭐️</td>
            <td>1 điểm</td>
          </tr>
          <tr>
            <td>200.000 ⭐️</td>
            <td>100 điểm</td>
          </tr>
        </tbody>
      </table>
      <p className="convert-title">Bảng quy đổi điểm Sao Cống hiến</p>
      <table>
        <thead>
          <tr>
            <th>Điểm bình chọn</th>
            <th>Phí bình chọn/lượt/tài khoản (VNĐ)</th>
          </tr>
        </thead>
        <tbody>
          {priceList.map((p, ind) => {
            return (
              <tr key={ind + 100}>
                <td>{p.combo}</td>
                <td>{p.price}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <h2 id="rule-title-6">QUY TRÌNH BÌNH CHỌN</h2>
      <UIList items={process} className="proccess-section">
        {(item, ind) => {
          return (
            <div className="card-item">
              <NumberText className="item-number">0{ind + 1}</NumberText>
              <GradientText className="item-title">{item.label}</GradientText>
              <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
            </div>
          );
        }}
      </UIList>
      <h2 id="rule-title-7">THỜI GIAN BÌNH CHỌN</h2>
      <p>
        Cổng bình chọn Giải thưởng Cống hiến 2023 sẽ bắt đầu mở từ 15h30 ngày
        04/01/2023 và kết thúc tại Đêm trao giải.
      </p>
    </Styles>
  );
};

const Styles = styled.div`
  .card {
    padding: 16px !important;
  }

  h3 {
    background: -webkit-linear-gradient(right, #3ff89f, #0384fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content;
    margin: 0 0 8px;

    &.title-2 {
      margin-top: 40px;
    }
  }

  ul {
    list-style: disc;
    margin: 0 0 0 40px;
  }

  table {
    border-collapse: separate;
    border-spacing: 8px;

    th {
      padding: 8px 20px;
      border-radius: 8px;
      background: linear-gradient(
        94.08deg,
        rgba(161, 91, 255, 0.3) 0%,
        rgba(255, 138, 90, 0.3) 100%
      );
      font-weight: 600;
    }

    td {
      padding: 8px 20px;
      border-radius: 8px;
      background: #2a3045;
      text-align: center;
    }
  }

  .convert-title {
    margin: 40px 0 16px;
  }

  .proccess-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;

    .card-item {
      border-radius: 12px;
      padding: 12px;
      background: linear-gradient(
        135deg,
        rgba(63, 248, 159, 0.1) 0%,
        rgba(3, 132, 252, 0.1) 100%
      );
    }

    .item-number {
      font-size: 48px;
      color: #1a2b30;
    }

    .item-title {
      background: -webkit-linear-gradient(right, #3ff89f, #0384fc);
      -webkit-background-clip: text;
      margin: -8px 0 20px;
    }
  }

  @media only screen and (max-width: 1199px) {
    .proccess-section {
      grid-template-columns: 1fr;
    }
  }
`;
